// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { lastDayOfWeek as fn } from "../lastDayOfWeek.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const lastDayOfWeek = convertToFP(fn, 1);

// Fallback for modularized imports:
export default lastDayOfWeek;
